const EASING_FUNCTIONS = {
    defaultEasing(t) {
        return t < 0.5
            ? (t * 2) ** 2 / 2
            : 1 - ((1 - t) * 2) ** 2 / 2;
    },
};

function scrollTo(destination = 0, opts = {}) {
    const {
        duration = 1000,
        easing = 'defaultEasing',
        offset = 0,
    } = opts;

    const start = window.pageYOffset;
    const startTime = new Date().getTime();

    const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight,
    );
    const windowHeight = window.innerHeight;
    const destinationOffset = typeof destination === 'number'
        ? destination
        : destination.offsetTop;
    const destinationOffsetToScroll = Math.round(
        documentHeight - destinationOffset < windowHeight
            ? documentHeight - windowHeight
            : destinationOffset - offset,
    );

    function scroll() {
        const now = new Date().getTime();
        const stepDuration = Math.min(1, ((now - startTime) / duration));
        const easingValue = EASING_FUNCTIONS[easing](stepDuration);
        window.scroll(0, Math.ceil((easingValue * (destinationOffsetToScroll - start)) + start));

        if (Math.abs(window.pageYOffset - destinationOffsetToScroll) < 1) {
            return;
        }

        requestAnimationFrame(scroll);
    }

    requestAnimationFrame(scroll);
}

function scrollToHash(id, opts = {}) {
    const regionEl = document.getElementById(id);
    if (regionEl) {
        scrollTo(regionEl, opts);
    }
}

export {
    scrollTo,
    scrollToHash,
};
